"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAemComponentData = getAemComponentData;
const component_data_util_1 = require("@owc/component-data-util");
/**
 * Read AEM dialogs
 * @param componentId e.g. dh-io-fcis, fcis-owdc
 */
function getAemComponentData(componentId) {
    return (0, component_data_util_1.getComponentData)(componentId);
}
